import Box from 'src/components/Box';
import { useSelector } from 'react-redux';
import { RootState } from 'src/store';
import { useMemo, useState } from 'react';
import RequestCard from 'src/components/Card/RequestCard';
import { Link } from 'react-router-dom';
import { convertMinToRoundedHours } from 'src/utils/stringHelpers';
import useProjectAccess from 'src/hooks/useProjectAccess';

const filters = [
  {
    label: 'All',
    value: 'all',
  },
  {
    label: 'Advertising',
    value: 'advertising',
  },
  {
    label: 'Design',
    value: 'design',
  },
  {
    label: 'Video',
    value: 'video',
  },
  {
    label: 'Website',
    value: 'website',
  },
  {
    label: 'AI',
    value: 'ai',
  },
  {
    label: 'Social media',
    value: 'social_media',
  },
];

const RequestListCreatePage = () => {
  const [selectedFilter, setSelectedFilter] = useState(filters[0]);

  const { canSeeRequestTime } = useProjectAccess();

  const listForms = useSelector(
    (state: RootState) => state.resources.requestForms
  );

  const filteredListForms = useMemo(() => {
    if (!selectedFilter || selectedFilter.value === 'all') {
      return listForms;
    }

    const filterValue = selectedFilter.value.toLowerCase();

    return listForms.filter((request) => {
      if (!request.groups || request.groups.length === 0) {
        return true;
      }

      return request.groups.includes(filterValue);
    });
  }, [selectedFilter, listForms]);

  return (
    <Box style={{ backgroundColor: '#f6f6f6' }}>
      <h1 className="text-[22px] font-semibold">
        Create a new request.{' '}
        <span style={{ color: '#6E6E6E' }}>
          Save time and bring your vision to life in just a few clicks.
        </span>
      </h1>

      <div className="my-6 flex flex-wrap gap-2">
        {filters.map((filter) => (
          <div
            key={filter.value}
            onClick={() => setSelectedFilter(filter)}
            className={`
              cursor-pointer 
              rounded-3xl 
              px-5 py-3 
              text-sm 
              transition-colors duration-300
              ${selectedFilter === filter ? 'bg-[#E4EFFE]' : 'bg-transparent'}
            `}
          >
            {filter.label}
          </div>
        ))}
      </div>

      <div className="mt-12 grid auto-rows-[400px] grid-cols-[repeat(auto-fill,_minmax(300px,_1fr))] gap-8">
        {filteredListForms.map((request) => {
          return (
            !request.disabled && (
              <RequestCard
                key={request.id}
                request={request}
                renderButton={() => {
                  return (
                    <Link to={`/requests/create/${request.id}`}>
                      <span className="text-base font-semibold leading-none">
                        Create request
                      </span>
                      {canSeeRequestTime && request.estimated_time && (
                        <span className="text-sm leading-none">
                          Starting{' '}
                          {convertMinToRoundedHours(request.estimated_time.min)}
                          h
                        </span>
                      )}
                    </Link>
                  );
                }}
              />
            )
          );
        })}
      </div>
    </Box>
  );
};

export default RequestListCreatePage;
